[
  {
    "code": "LV-011",
    "name": "Adaži"
  },
  {
    "code": "LV-001",
    "name": "Aglona"
  },
  {
    "code": "LV-002",
    "name": "Aizkraukle"
  },
  {
    "code": "LV-003",
    "name": "Aizpute"
  },
  {
    "code": "LV-004",
    "name": "Akniste"
  },
  {
    "code": "LV-005",
    "name": "Aloja"
  },
  {
    "code": "LV-006",
    "name": "Alsunga"
  },
  {
    "code": "LV-007",
    "name": "Aluksne"
  },
  {
    "code": "LV-008",
    "name": "Amata"
  },
  {
    "code": "LV-009",
    "name": "Ape"
  },
  {
    "code": "LV-010",
    "name": "Auce"
  },
  {
    "code": "LV-012",
    "name": "Babite"
  },
  {
    "code": "LV-013",
    "name": "Baldone"
  },
  {
    "code": "LV-014",
    "name": "Baltinava"
  },
  {
    "code": "LV-015",
    "name": "Balvi"
  },
  {
    "code": "LV-016",
    "name": "Bauska"
  },
  {
    "code": "LV-017",
    "name": "Beverina"
  },
  {
    "code": "LV-018",
    "name": "Broceni"
  },
  {
    "code": "LV-019",
    "name": "Burtnieki"
  },
  {
    "code": "LV-020",
    "name": "Carnikava"
  },
  {
    "code": "LV-022",
    "name": "Cesis"
  },
  {
    "code": "LV-021",
    "name": "Cesvaine"
  },
  {
    "code": "LV-023",
    "name": "Cibla"
  },
  {
    "code": "LV-024",
    "name": "Dagda"
  },
  {
    "code": "LV-025",
    "name": "Daugavpils"
  },
  {
    "code": "LV-DGV",
    "name": "Daugavpils City"
  },
  {
    "code": "LV-026",
    "name": "Dobele"
  },
  {
    "code": "LV-027",
    "name": "Dundaga"
  },
  {
    "code": "LV-028",
    "name": "Durbe"
  },
  {
    "code": "LV-029",
    "name": "Engure"
  },
  {
    "code": "LV-030",
    "name": "Ergli"
  },
  {
    "code": "LV-031",
    "name": "Garkalne"
  },
  {
    "code": "LV-032",
    "name": "Grobina"
  },
  {
    "code": "LV-033",
    "name": "Gulbene"
  },
  {
    "code": "LV-034",
    "name": "Iecava"
  },
  {
    "code": "LV-035",
    "name": "Ikškile"
  },
  {
    "code": "LV-036",
    "name": "Ilukste"
  },
  {
    "code": "LV-037",
    "name": "Incukalns"
  },
  {
    "code": "LV-038",
    "name": "Jaunjelgava"
  },
  {
    "code": "LV-039",
    "name": "Jaunpiebalga"
  },
  {
    "code": "LV-040",
    "name": "Jaunpils"
  },
  {
    "code": "LV-042",
    "name": "Jekabpils"
  },
  {
    "code": "LV-JKB",
    "name": "Jekabpils City"
  },
  {
    "code": "LV-041",
    "name": "Jelgava"
  },
  {
    "code": "LV-JEL",
    "name": "Jelgava City"
  },
  {
    "code": "LV-JUR",
    "name": "Jurmala City"
  },
  {
    "code": "LV-043",
    "name": "Kandava"
  },
  {
    "code": "LV-044",
    "name": "Karsava"
  },
  {
    "code": "LV-051",
    "name": "Kegums"
  },
  {
    "code": "LV-052",
    "name": "Kekava"
  },
  {
    "code": "LV-045",
    "name": "Koceni"
  },
  {
    "code": "LV-046",
    "name": "Koknese"
  },
  {
    "code": "LV-047",
    "name": "Kraslava"
  },
  {
    "code": "LV-048",
    "name": "Krimulda"
  },
  {
    "code": "LV-049",
    "name": "Krustpils"
  },
  {
    "code": "LV-050",
    "name": "Kuldiga"
  },
  {
    "code": "LV-053",
    "name": "Lielvarde"
  },
  {
    "code": "LV-LPX",
    "name": "Liepaja City"
  },
  {
    "code": "LV-055",
    "name": "Ligatne"
  },
  {
    "code": "LV-054",
    "name": "Limbaži"
  },
  {
    "code": "LV-056",
    "name": "Livani"
  },
  {
    "code": "LV-057",
    "name": "Lubana"
  },
  {
    "code": "LV-058",
    "name": "Ludza"
  },
  {
    "code": "LV-059",
    "name": "Madona"
  },
  {
    "code": "LV-061",
    "name": "Malpils"
  },
  {
    "code": "LV-062",
    "name": "Marupe"
  },
  {
    "code": "LV-060",
    "name": "Mazsalaca"
  },
  {
    "code": "LV-063",
    "name": "Mersrags"
  },
  {
    "code": "LV-064",
    "name": "Naukšeni"
  },
  {
    "code": "LV-065",
    "name": "Nereta"
  },
  {
    "code": "LV-066",
    "name": "Nica"
  },
  {
    "code": "LV-067",
    "name": "Ogre"
  },
  {
    "code": "LV-068",
    "name": "Olaine"
  },
  {
    "code": "LV-069",
    "name": "Ozolnieki"
  },
  {
    "code": "LV-070",
    "name": "Pargauja"
  },
  {
    "code": "LV-071",
    "name": "Pavilosta"
  },
  {
    "code": "LV-072",
    "name": "Plavinas"
  },
  {
    "code": "LV-073",
    "name": "Preili"
  },
  {
    "code": "LV-074",
    "name": "Priekule"
  },
  {
    "code": "LV-075",
    "name": "Priekuli"
  },
  {
    "code": "LV-076",
    "name": "Rauna"
  },
  {
    "code": "LV-077",
    "name": "Rezekne"
  },
  {
    "code": "LV-REZ",
    "name": "Rezekne City"
  },
  {
    "code": "LV-078",
    "name": "Riebini"
  },
  {
    "code": "LV-RIX",
    "name": "Riga City"
  },
  {
    "code": "LV-079",
    "name": "Roja"
  },
  {
    "code": "LV-080",
    "name": "Ropaži"
  },
  {
    "code": "LV-081",
    "name": "Rucava"
  },
  {
    "code": "LV-082",
    "name": "Rugaji"
  },
  {
    "code": "LV-084",
    "name": "Rujiena"
  },
  {
    "code": "LV-083",
    "name": "Rundale"
  },
  {
    "code": "LV-085",
    "name": "Sala"
  },
  {
    "code": "LV-086",
    "name": "Salacgriva"
  },
  {
    "code": "LV-087",
    "name": "Salaspils"
  },
  {
    "code": "LV-088",
    "name": "Saldus"
  },
  {
    "code": "LV-089",
    "name": "Saulkrasti"
  },
  {
    "code": "LV-090",
    "name": "Seja"
  },
  {
    "code": "LV-091",
    "name": "Sigulda"
  },
  {
    "code": "LV-092",
    "name": "Skriveri"
  },
  {
    "code": "LV-093",
    "name": "Skrunda"
  },
  {
    "code": "LV-094",
    "name": "Smiltene"
  },
  {
    "code": "LV-095",
    "name": "Stopini"
  },
  {
    "code": "LV-096",
    "name": "Strenci"
  },
  {
    "code": "LV-097",
    "name": "Talsi"
  },
  {
    "code": "LV-098",
    "name": "Tervete"
  },
  {
    "code": "LV-099",
    "name": "Tukums"
  },
  {
    "code": "LV-100",
    "name": "Vainode"
  },
  {
    "code": "LV-101",
    "name": "Valka"
  },
  {
    "code": "LV-VMR",
    "name": "Valmiera City"
  },
  {
    "code": "LV-102",
    "name": "Varaklani"
  },
  {
    "code": "LV-103",
    "name": "Varkava"
  },
  {
    "code": "LV-104",
    "name": "Vecpiebalga"
  },
  {
    "code": "LV-105",
    "name": "Vecumnieki"
  },
  {
    "code": "LV-106",
    "name": "Ventspils"
  },
  {
    "code": "LV-VEN",
    "name": "Ventspils City"
  },
  {
    "code": "LV-107",
    "name": "Viesite"
  },
  {
    "code": "LV-108",
    "name": "Vilaka"
  },
  {
    "code": "LV-109",
    "name": "Vilani"
  },
  {
    "code": "LV-110",
    "name": "Zilupe"
  }
]